import React from 'react';
import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';

import { asField } from 'informed';
import { get } from 'lodash-es';

import './NumberFormat.scss';

const CurrencyFieldComponent = props => {
  // eslint-disable-next-line react/prop-types
  const { fieldApi, fieldState } = props;
  const value = get(fieldState, 'value');
  const setValue = get(fieldApi, 'setValue');
  const setTouched = get(fieldApi, 'setTouched');
  const {
    onChange,
    // eslint-disable-next-line react/prop-types
    // onBlur,
    prefix,
    allowNegative,
    decimalScale,
    decimalSeparator,
    thousandSeparator,
    fixedDecimalScale,
    forwardedRef,
    disabled,
    // ...rest
  } = props;

  return (
    <>
      <NumberFormat
        // {...rest}
        value={!value && value !== 0 ? '' : value}
        getInputRef={forwardedRef}
        onValueChange={values => {
          if (setValue) setValue(values.floatValue);
          if (onChange) {
            onChange({
              target: {
                value: values.floatValue,
              },
            });
          }
          setTouched();
        }}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        fixedDecimalScale={fixedDecimalScale}
        prefix={prefix}
        allowNegative={allowNegative}
        decimalScale={decimalScale}
        className="number-format"
        disabled={disabled}
        style={get(fieldState, 'error') ? { border: 'solid 1px red' } : null}
      />
      {get(fieldState, 'error') ? <small style={{ color: 'red' }}>{get(fieldState, 'error')}</small> : null}
    </>
  );
};

CurrencyFieldComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  decimalScale: PropTypes.number,
  fixedDecimalScale: PropTypes.bool,
  prefix: PropTypes.string,
  allowNegative: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  forwardedRef: PropTypes.string,
};

CurrencyFieldComponent.defaultProps = {
  thousandSeparator: ' ',
  decimalSeparator: ',',
  decimalScale: 2,
  fixedDecimalScale: false,
  prefix: '€',
  allowNegative: false,
  forwardedRef: '',
  onKeyDown: e => {
    const { key, target } = e;
    const { selectionStart, value } = target;
    if (key === '.') {
      e.preventDefault();
      target.value = `${value.substr(0, selectionStart)},${value.substr(selectionStart, value.length)}`;
    }
  },
  disabled: false,
};

export default asField(CurrencyFieldComponent);
